<template>
    <div :id="hash">
        <ClientOnly>
            <div ref="target"></div>
        </ClientOnly>
    </div>
</template>

<script>
// This component will scroll into view when it is mounted if the passed hash is in the route

export default {
    name: 'LayoutScrollIntoView',
    props: {
        hash: {
            required: true,
            type: String,
            validator (value) {
                if (value.startsWith('#')) return true;
                console.error('Hash prop in LayoutScrollIntoView must start with a hash (#)');
                return false;
            }
        },
        behavior: {
            required: false,
            type: [String, undefined],
            default: undefined
        }
    },
    mounted() {
        if (useRoute().hash !== this.hash) return;
        nextTick(() => {
            this.$refs.target.scrollIntoView({behavior: this.behavior});
        });
    }
};

</script>
